import { Package } from "./package.model";

export class PackageMapper {
  public static map(data: any, isMeasurementRequired: boolean = true): Package {
    return new Package(
      data.quantity,
      data.length,
      data.width,
      data.height,
      data.measurement,
      data.weight,
      data.ldm,
      data.pallet,
      data.stackable,
      isMeasurementRequired,
    );
  }
}
